import { combineReducers } from 'redux-immutable'
import { default as app } from './app-reducer'
import { default as forms } from './forms-reducer'

export function initApp () {
  return dispatch => {
    // dispatch(fetchUserProfile())
  }
}

const rootReducer = combineReducers({
  app,
  forms
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/redux/root-reducer.js